import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seller-reports',
  templateUrl: './seller-reports.component.html',
  styleUrls: ['./seller-reports.component.scss']
})
export class SellerReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
